export const clientsGetters = {
    getId: (params) => params.data.id,
    getFantasyName: (params) => params.data.name,
    getHoldingId: (params) => params.data.holding_id || '-',
    holdingNameGetter: (params) => (params.data.holding_id ? `${params.data.holding_name} (${params.data.holding_id})` : '-'),
    properties: {
        getBillingMoment: (params) => {
            const existProperties = params.data.properties
            const billingMoment = existProperties ? existProperties.billing_moment : '-'

            return billingMoment || '-'
        },
        getPaymentMode: (params) => {
            const existProperties = params.data.properties
            const paymentMethod = existProperties ? existProperties.payment_mode : '-'

            return paymentMethod || '-'
        },
        getPaymentTimeLimit: (params) => {
            const existProperties = params.data.properties
            const timeLimit = existProperties ? existProperties.payment_term : '-'

            return timeLimit || '-'
        },
        getChargeTimeLimit: (params) => {
            const existProperties = params.data.properties
            const timeLimit = existProperties ? existProperties.charge_term : '-'

            return timeLimit || '-'
        },
        getAgencyCommissionMode: (params) => {
            const existProperties = params.data.properties
            const agencyCommissionMode = existProperties ? existProperties.agency_commission_mode : '-'

            return agencyCommissionMode || '-'
        }
    },
    billingInformation: {
        getLegalName: (params) => (params.data.billing_information ? params.data.billing_information.fantasy_name : '-'),
        getTaxId: (params) => {
            const billingInformation = params.data.billing_information
            const taxId = billingInformation ? billingInformation.tax_id : '-'

            if (!taxId) return '-'

            return taxId.trim()
        },
        getAddress: (params) => {
            const billingInformation = params.data.billing_information
            const address = billingInformation ? billingInformation.address : '-'
            
            if (!address) return '-'

            return address.trim()
        },
        getCity: (params) => params.data.billing_information.city,
        getState: (params) => params.data.billing_information.state,
    }
}